import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

const URL_PATH = 'api/itemAta/bloqueio'

class BloqueioApiClient {
	async bloquearItens(dados) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/bloquear`,
		}).build()
		return await axios.put(URL, dados)
	}

	async desbloquearItens(dados) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/desbloquear`,
		}).build()
		return await axios.put(URL, dados)
	}

	async buscarHistoricoBloqueio(idItemAta, paginacao) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/historico`,
			filters: { idItemAta: idItemAta },
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(URL)
	}
}

export default new BloqueioApiClient()
